import { render } from "./TrashIcon.vue?vue&type=template&id=c1fc265a"
const script = {}
script.render = render

export default script